import React from 'react';
import PropTypes from 'prop-types';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from '../../src/i18n';
import { colors, fontSize } from '../../constants/styleConstants';
import FbTabsSection from '../FbTabsSection';
import RepertorieTable from '../RepertorieTable';
import DropdownButton from '../DropdownButton';
import MoreButton from '../MoreButton';
import { TP } from '../../constants/consts';

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 40,
    '& p': {
      fontSize: fontSize.regularTitle,
      fontWeight: 'bold',
      color: colors.grey3,
      margin: 0,
    },
  },
  arrowIcon: {
    margin: 'auto',
    marginRight: 0,
    '& svg': {
      cursor: 'pointer',
      color: colors.blueChip,
      fontSize: '1.1rem',
    },
  },
  appBarClass: {
    border: 0,
    padding: 0,
  },

  tabClasses: {
    fontSize: fontSize.basic,
    minWidth: 'fit-content',
    padding: '0 10px',
    textTransform: 'capitalize',
    minHeight: '40px',
    '& .MuiTab-wrapper': {
      color: '#555555',
    },
  },
  tabsClasses: {
    minHeight: '40px',
  },
  selectMenu: {
    width: '125px',
    marginLeft: '20px',
    '& .MuiInputBase-input': {
      cursor: 'pointer !important',
      padding: '5px 0 5px 10px !important',
      borderRadius: '7px  !important',
      border: 'solid 1px #dddddd !important',
      color: '#4b4b4b  !important',
      fontSize: '12px  !important',
      '& .MuiSvgIcon-root': {
        fill: `${colors.blueChip} !important`,
      },
    },
  },
  moreButton: {
    marginTop: '12px',
    marginBottom: 20,
  },
});

const TAB_NAMES = {
  WISHLIST: 'wishlist',
  REPERTOIRE: 'repertoire',
};

const FILTER_STATUSES = {
  ALL: 'all',
  RETIRE: 'retire',
  ACTIVE: 'active',
};

const ArtistRepertoireView = ({ all, future, retired, active, showMoreCard, goToTab, profile }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [list, setList] = React.useState(all);

  const tabs = [
    {
      name: `${t(`${TP}.m_LISTREPERTOIRE`)} `,
      value: TAB_NAMES.REPERTOIRE,
      isShown: true,
    },
    {
      name: `${t(`${TP}.WISHLIST`)} `,
      value: TAB_NAMES.WISHLIST,
      isShown: future?.length > 0,
    },
  ];

  const filterOptions = [
    {
      label: `${t(`${TP}.FILTER`)}:  ${t(`${TP}.m_ALL`)}`,
      value: 1,
      name: `${t(`${TP}.FILTER`)}:  ${t(`${TP}.m_ALL`)}`,
      status: FILTER_STATUSES.ALL,
    },
    {
      label: `${t(`${TP}.FILTER`)}:  ${t(`${TP}.RETIRED`)}`,
      value: 2,
      name: `${t(`${TP}.FILTER`)}:  ${t(`${TP}.RETIRED`)}`,
      status: FILTER_STATUSES.RETIRE,
    },
    {
      label: `${t(`${TP}.FILTER`)}:  ${t(`${TP}.ACTIVE`)}`,
      value: 3,
      name: `${t(`${TP}.FILTER`)}:  ${t(`${TP}.ACTIVE`)}`,
      status: FILTER_STATUSES.ACTIVE,
    },
  ];
  const [selectedTab, setSelectedTab] = React.useState(tabs[0].value);
  const [choosenFilter, setFilter] = React.useState(filterOptions[0]);

  const onChangeHomeTab = () => {
    goToTab('repertoire');
  };

  const setRepertoireList = filter => {
    switch (filter) {
      case FILTER_STATUSES.ALL:
        return all;
      case FILTER_STATUSES.ACTIVE:
        return active;
      case FILTER_STATUSES.RETIRE:
        return retired;
      default:
        return all;
    }
  };

  const onChangeTab = value => {
    setSelectedTab(value);
    if (value === TAB_NAMES.WISHLIST) {
      setList(future);
    } else {
      setList(setRepertoireList(choosenFilter.status));
    }
  };

  const onFilterChange = value => {
    setFilter(value);
    if (selectedTab !== TAB_NAMES.REPERTOIRE) {
      setSelectedTab(tabs[0].value);
    }
    setList(setRepertoireList(value.status));
  };

  return (
    <div>
      <div className={classes.header}>
        <p>{t(`${TP}.m_LISTREPERTOIRE`)}</p>
        {!showMoreCard && (
          <div className={classes.selectMenu}>
            <DropdownButton onChange={onFilterChange} options={filterOptions} selectedValue={choosenFilter} />
          </div>
        )}

        {showMoreCard && (
          <div className={classes.arrowIcon}>
            <ArrowForwardIcon onClick={onChangeHomeTab} />
          </div>
        )}
      </div>

      <div className={classes.tabSection}>
        {tabs && (
          <FbTabsSection
            tabs={tabs.filter(item => item.isShown)}
            appBarClass={classes.appBarClass}
            onChange={onChangeTab}
            initialTabValue={selectedTab}
            tabModel="normal"
            tabClasses={classes.tabClasses}
            tabsClasses={classes.tabsClasses}
          />
        )}
        <RepertorieTable repertoireGrouped={list} profile={profile} />
        {showMoreCard && (
          <MoreButton className={classes.moreButton} buttonText={t(`${TP}.MORE_REPERTOIRE`)} action={onChangeHomeTab} />
        )}
      </div>
    </div>
  );
};

ArtistRepertoireView.propTypes = {
  showMoreCard: PropTypes.bool,
  goToTab: PropTypes.func,
};

export default React.memo(ArtistRepertoireView);
